import { config } from "server/config";

export const isPublishedPageReferer = (referer?: string): boolean => {
  if (!referer) return false;
  const url = new URL(referer);
  return url.origin !== config().NEXT_PUBLIC_INTERFACES_BASE_URL;
};
